import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  otButtonVariants,
  otButtonSizes,
  otButtonRounded,
  type OtButtonVariant,
  type OtButtonSize,
  type OtButtonRounded,
  type OtButtonHrefCustomIconAttrs,
} from '@1trading/design-system';
import { type PropType } from 'vue';

import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';

import { nativeOpenLink } from './link-external-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'XButton',
  props: {
  activeNav: { type: Boolean, default: false },
  block: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  href: { type: String, required: false },
  hrefCustomIcon: { type: Object as PropType<OtButtonHrefCustomIconAttrs>, required: false },
  loading: { type: Boolean, default: false },
  round: { type: Boolean, default: false },
  rounded: { type: String as PropType<OtButtonRounded>, default: otButtonRounded.null },
  size: { type: String as PropType<OtButtonSize>, default: otButtonSizes.md },
  text: { type: String, required: false },
  to: { type: [String, Object], required: false },
  useSystemBrowser: { type: Boolean, default: false } /** Native only: Use in conjunction with href to determine whether system or in-app browser is used. */,
  variant: { type: String as PropType<OtButtonVariant>, default: otButtonVariants.base },
},
  emits: ["click", "native-open-link"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isNative = capIsNativePlatform();

const onNativeOpenLink = () => {
  if (props.href && isNative) {
    nativeOpenLink(props.href, props.useSystemBrowser);
  }
};
const onClick = (e: Event) => {
  emit('click', e);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_button = _resolveComponent("ot-button")!

  return (_openBlock(), _createBlock(_component_ot_button, {
    class: "x-button",
    "active-nav": __props.activeNav,
    block: __props.block,
    disabled: __props.disabled,
    "href-custom-icon": __props.hrefCustomIcon,
    href: __props.href,
    "is-native": _unref(isNative),
    loading: __props.loading,
    round: __props.round,
    rounded: __props.rounded,
    size: __props.size,
    text: __props.text,
    to: __props.to,
    variant: __props.variant,
    onClick: onClick,
    onNativeOpenLink: onNativeOpenLink
  }, _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1032, ["active-nav", "block", "disabled", "href-custom-icon", "href", "is-native", "loading", "round", "rounded", "size", "text", "to", "variant"]))
}
}

})